import React from 'react';
import {Button} from 'react-bootstrap';
import PropTypes from 'prop-types';

const SaveButton = ({
    onClick,
    small,
}) => {
    return (<Button variant="outline-success" className={'text-success ms-1' + (small ? ' p-1' : '')}
        onClick={onClick}>
        <i className="fa-solid fa-floppy-disk"/>
    </Button>);
};

SaveButton.defaultProps = {
    small: false,
};

SaveButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    small: PropTypes.bool,
};

export default SaveButton;
